exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-gatsby-starter-index-tsx": () => import("./../../../src/pages/gatsby-starter-index.tsx" /* webpackChunkName: "component---src-pages-gatsby-starter-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-release-tsx": () => import("./../../../src/templates/release.tsx" /* webpackChunkName: "component---src-templates-release-tsx" */)
}

